import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal, NgbDateParserFormatter, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';

@Component({
  selector: 'app-expense-form-sort',
  standalone: true,
  imports: [LoaderComponent, CommonModule, FormsModule, NgbDatepickerModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './expense-form-sort.component.html',
  styleUrl: './expense-form-sort.component.scss'
})
export class ExpenseFormSortComponent {
  isDisabled: boolean = false;
  Data = {
    TripName: null,
    FromDate: null,
    ToDate: null,
  }

  constructor(
    private activeModal: NgbActiveModal,
  ) { }

  Verification(form: any) {
    if (form.valid) {
      this.activeModal.close(this.Data);
    }
    else {
      form.submitted = true;
    }
  }

  close() {
    this.activeModal.close();
  }
}
